/* eslint-disable @typescript-eslint/naming-convention */
import useTimeAgo from '@rooks/use-time-ago'
import { useState, useEffect, useMemo } from 'react'
import type { FC } from 'react'
import { CartProduct } from 'framework/cart'
import { useCart, useNotification } from 'hooks'
import { ButtonAddToCart } from 'modules/products/components'
import type { ProductBuyProps } from '.'

interface Item {
  id: string
  isAtacado: boolean
  price: number
  quantity?: number
  period?: string
  itemTotal?: number
  type: 'convencional' | 'experiencia'
  delivery_method: string,
  [key: string]: any,
}

const ProductBuy: FC<ProductBuyProps> = ({ product, quantity = 1, ...props }) => {
  const { addItem, getItem, inCart } = useCart()
  const [item, setItem] = useState<CartProduct>(undefined as unknown as CartProduct)
  const { notify } = useNotification()

  useEffect(() => {
    setItem(getItem(product.id))
  }, [product, getItem, setItem])

  const productLastChange = useTimeAgo(item?.lastChange || new Date(), {
    intervalMs: 1000,
    locale: 'pt_BR',
    relativeDate: new Date(),
  })

  const added = useMemo(() => {
    return inCart(product.id)
  }, [inCart, product])

  function onClick(subscription: boolean = false) {
    const {
      id,
      name,
      image,
      price,
      preco_promocional,
      preco_promocional_ativo,
      stock,
      slug,
      assinatura_desconto_produtor,
      assinatura_frete_gratis,
      assinatura_desconto_frete,
      categories,
    } = product
    if (price.sell <= 0) {
      notify({
        title: 'Atenção',
        description: 'Produtos sem valor definido não pode ser adicionado a carrinho',
        type: 'danger',
      })
      return
    }

    if (quantity > stock) {
      notify({
        title: 'Sem estoque suficiente',
        description: 'Diminua a quantidade para poder continuar',
        type: 'danger',
      })
      return
    }

    const isAtacado = categories?.atacado === 'Atacado' || false

    addItem(
      {
        id,
        isAtacado,
        assinatura_desconto_produtor,
        assinatura_frete_gratis,
        assinatura_desconto_frete,
        assinatura: subscription,
        type: item && item.type ? item.type : 'convencional',
        name,
        slug,
        imageUrl: image || (product.images?.length > 0 ? product.images[0]?.url : undefined),
        price: preco_promocional_ativo && preco_promocional > 0 ? preco_promocional : price.sell,
        quantity,
        itemTotal: price.sell * quantity,
        lastChange: new Date(),
        seller: product.seller,
        delivery_method: 'retirada-local',
      } as Item,
      quantity,
    )

    notify({ title: 'Adicionado ao carrinho', description: `${quantity}x ${product.name}`, type: 'success' })
  }

  return <ButtonAddToCart {...props} product={product} quantity={quantity} inCart={added ? productLastChange : null} onClick={onClick} />
}

export default ProductBuy
